angular.module(NgAppName).service('fbService', ['$q', function($q) {
	this.getInfo = function() {
		var deferred = $q.defer();
		FB.api('/me', {
			fields: 'first_name, last_name, email'
		}, function(response) {
			if (!response || response.error) {
				deferred.reject('Error occured');
			} else {
				deferred.resolve(response);
			}
		});

		return deferred.promise;
	};

	this.login = function() {
		var deferred = $q.defer();
		FB.login(function(response) {
			if (!response || response.error) {
				deferred.reject('Error occured');
			} else {
				deferred.resolve(response);
			}
		}, {
			scope: 'email',
			auth_type: 'rerequest'}
		);
		return deferred.promise;
	};

	this.getLoginStatus = function() {
		var deferred = $q.defer();
		FB.getLoginStatus(function(response) {
			if (!response || response.error) {
				deferred.reject('Error occured');
			} else {
				deferred.resolve(response);
			}
		});
		return deferred.promise;
	};
}]);
